exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader {\n  position: fixed;\n  z-index: 99999;\n  background-color: rgba(255, 255, 255, 0.4);\n  width: 90%;\n  height: 85%;\n}\n.loader img {\n  max-width: 100%;\n}\n", ""]);

// exports
